"use client";

import React from "react";
import { SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { Badge } from "@/components/ui/badge";
import parse from "html-react-parser";
import { SectionWrapper } from "../components/SectionWraper";

interface FeatureItem {
  icon?: string;
  title?: string;
  content?: string;
}

interface Feature21Props { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  badge?: string;
  title?: string;
  content?: string;
  items?: FeatureItem[];
  attributes?: React.HTMLProps<HTMLElement>;
}

const Feature21 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Feature 21",
  themeChangeOnScroll = false,
  badge,
  title,
  content,
  items,
  attributes,
}: Feature21Props) => {

  // Function to determine grid columns based on item count
  const getGridClasses = (itemCount: number) => {
    if (itemCount <= 1) {
      return "grid-cols-1";
    } else if (itemCount === 2) {
      return "grid-cols-1 md:grid-cols-2";
    } else if (itemCount === 3) {
      return "grid-cols-1 md:grid-cols-3";
    } else {
      return "grid-cols-1 md:grid-cols-2 xl:grid-cols-4";
    }
  };

  const itemCount = items?.length || 0;
  const gridClasses = getGridClasses(itemCount);

  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature21"
      attributes={attributes}
    >
      <div className="container flex flex-col gap-14 md:gap-20" data-aos="fade-up">
        <div className="flex flex-col gap-6 text-center items-center" >
          {badge && (
            <Badge variant="outline" bold>
              {badge}
            </Badge>
          )}
          {title && (
            <h2 className="md:max-w-[500px] lg:max-w-[800px]">
              {parse(title)}
            </h2>
          )}
          {content && (
            <div className="paragraph-lg text-muted-foreground md:max-w-[65ch] mb-4">
              {parse(content)}
            </div>
          )}
        </div>
       
        <div className={`grid ${gridClasses} lg:gap-6`}>
          {items && items.length > 0 && items?.slice(0, 4).map((item, index) => (
            <div key={index} className="relative flex flex-row md:flex-col gap-6 rounded-lg border-dashed md:block md:border-l px-0 py-4 md:px-6 md:py-6">
              {item.icon && (
                <span className="mb-8 flex size-12 shrink-0 items-center justify-center rounded-full bg-accent">
                  <span className="material-symbols-outlined">
                    {item.icon}
                  </span>
                </span>
              )}
              <div>
                {item.title && (
                  <div className="paragraph-lg font-bold">
                    {item.title}
                  </div>
                )}
                {item.content && (  
                  <div className="paragraph-base text-muted-foreground mt-2">
                    {parse(item.content ?? "")}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Feature21 };



